import React from 'react';
import styles from './SectionSelector.module.css'
import { useDispatch } from 'react-redux';
import {  toggleSections } from '../LiveSlice';

interface Props {
  title: String
  isCurrentGames: Boolean
  isActive: Boolean
  style: React.CSSProperties
}

const SectionSelector = ({ title, isCurrentGames, isActive, style }: Props) => {
  const dispatch = useDispatch()
  const sectionClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.stopPropagation()
    dispatch(toggleSections({ section: isCurrentGames ? 'current' : 'today', value: !isActive }))    
    // dispatch(fetchLiveChampionships())
  }

  return (
    <a onClick={sectionClick} style={isCurrentGames ? {} : style}
        className={`${styles.sectionSelector} 
        ${isActive ? styles.active : ''}`}>
            
          {title} <strong>LIVE</strong>

    </a>
  )
}

export default SectionSelector